export var ManageUser;
(function (ManageUser) {
    ManageUser["ManageUser"] = "ManageUser/ManageUser";
    ManageUser["ManageUser_Sucessful"] = "ManageUser/Sucessful";
    ManageUser["ManageUser_Error"] = "ManageUser/Error";
    ManageUser["ManageUserDashboard"] = "ManageUser/Dashboard";
    ManageUser["ManageUserDashboard_Sucessful"] = "ManageUser/Dashboard_sucessful";
    ManageUser["ManageUserDashboard_Empty"] = "ManageUser/Dashboard_Empty";
    ManageUser["ManageUserDashboard_Error"] = "ManageUser/Dashboard_Error";
    ManageUser["FetchCaseload"] = "ManageUser/FetchCaseload";
    ManageUser["FetchCaseload_Successful"] = "ManageUser/FetchCaseload_Successful";
    ManageUser["FetchCaseload_Error"] = "ManageUser/FetchCaseload_Error";
    ManageUser["ManageExportUsers"] = "ManageUser/exportUsers";
    ManageUser["ManageExportUsers_Sucessful"] = "ManageUser/exportUsers_sucessful";
    ManageUser["ManageArchiveUsers"] = "ManageUser/archiveUsers";
    ManageUser["ManageArchiveUsers_Sucessful"] = "ManageUser/archiveUsers_sucessful";
    ManageUser["ManageDeleteUsers"] = "ManageUser/deleteUsers";
    ManageUser["ManageDeleteUsers_Sucessful"] = "ManageUser/deleteUsers_sucessful";
    ManageUser["ManageCreateUser"] = "ManageUser/MangeCreateUser";
    ManageUser["ManageCreateUser_Successful"] = "ManageUser/MangeCreateUserSuccessful";
    ManageUser["ManageCreateUser_Error"] = "ManageUser/MangeCreateUserError";
    ManageUser["ForceBlrRecalculation"] = "ManageUser/ForceBlrRecalculation";
    ManageUser["ForceBlrRecalculation_Successful"] = "ManageUser/ForceBlrRecalculation_Successful";
    ManageUser["ForceBlrRecalculation_Error"] = "ManageUser/ForceBlrRecalculation_Error";
})(ManageUser || (ManageUser = {}));
